import { render, staticRenderFns } from "./SubmissionCardContainer.vue?vue&type=template&id=57ea0b44&"
import script from "./SubmissionCardContainer.vue?vue&type=script&lang=js&"
export * from "./SubmissionCardContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports